/** Analytics Portal V1 — loading skeletons (Phase 9). Announced politely so a screen reader
 * hears that data is loading rather than reading an empty region. */
import React from "react";
import { Card } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

export const LoadingSkeleton = ({ cards = 4, charts = 2, blurred = false }) => (
  <div className={blurred ? "pointer-events-none select-none blur-[6px]" : ""}
       data-testid="analytics-loading" role="status" aria-live="polite"
       aria-label={blurred ? "Analytics preview" : "Loading analytics"}>
    {!blurred && <span className="sr-only">Loading analytics…</span>}
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-4">
      {Array.from({ length: cards }).map((_, index) => (
        <Card key={index} className="p-4">
          <Skeleton className="h-3 w-24" />
          <Skeleton className="mt-3 h-7 w-20" />
          <Skeleton className="mt-2 h-3 w-16" />
        </Card>
      ))}
    </div>
    <div className="mt-4 grid grid-cols-1 gap-3 xl:grid-cols-2">
      {Array.from({ length: charts }).map((_, index) => (
        <Card key={index} className="p-5">
          <Skeleton className="h-4 w-40" />
          <Skeleton className="mt-4 h-[200px] w-full" />
        </Card>
      ))}
    </div>
  </div>
);
